import style from "./MultiSelect.module.css"
function MultiSelect({secDelay, setSecDelay }) {
  return (
    <div className={style.multiSelect}>
      <label>Select Delay (in sec):</label>
      <div className={style.selectContainer}>
        {[...Array(5).keys()].map((option, index) => (
          <button key={'sec'+ index} className={secDelay === option+1? `${style.active}` : ""} onClick={() => setSecDelay(option+1)}>{option+1}</button>
        ))}
      </div>
    </div>
  );
}

export default MultiSelect;